import * as React from 'react';

import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {FollowUpTasksOnboardingModal} from '../onboarding/follow-up-tasks-onboarding/follow-up-tasks-onboarding-modal';
import {useShouldShowFollowUpTasksOnboarding} from '../onboarding/follow-up-tasks-onboarding/use-should-show-follow-up-task-onboarding';

export function LeadModals() {
    const {user} = useGetSessionUser();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const {shouldShow, markSeen} = useShouldShowFollowUpTasksOnboarding(
        Nut_Settings_User.SETTING_HAS_SEEN_FOLLOW_UP_TASKS_ONBOARDING_MODAL
    );

    React.useEffect(() => {
        if (shouldShow) {
            setIsModalOpen(true);
        }
    }, [shouldShow]);

    if (!user) {
        return null;
    }

    return (
        <FollowUpTasksOnboardingModal
            isOpen={isModalOpen}
            user={user}
            onClose={() => {
                if (markSeen) {
                    markSeen();
                    setIsModalOpen(false);
                }
            }}
        />
    );
}
